<!-- InstagramDirectCallback.vue - same flow as LoginFallback but for Instagram Direct OAuth -->
<template>
  <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
    الرجاء الانتظار قليلا ...
  </div>
</template>

<script>
import AuthApi from '@/api/auth'
import InstagramAccountsApi from '@/api/instagram/account'
import { redirectToHomeIfInWebView } from '@/utils/flutter-webview'

export default {
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const state = urlParams.get('state')
    const error = urlParams.get('error')
    const errorDescription = urlParams.get('error_description')

    // Popup case: send result to opener and close
    if (window.opener) {
      if (code) {
        window.opener.postMessage({
          type: 'instagram_oauth_callback',
          code,
          state,
        }, window.location.origin)
      } else if (error) {
        window.opener.postMessage({
          type: 'instagram_oauth_callback',
          error: errorDescription || error,
        }, window.location.origin)
      }
      window.close()
      return
    }

    // Same-window / WebView: handle like LoginFallback (Instagram Direct flow)
    if (!code) {
      if (error) {
        this.$notifyError(errorDescription || error)
      }
      this.$router.push({ name: 'login' })
      return
    }

    const self = this
    try {
      const response = await AuthApi.loginByCode({
        code,
        state: state || '',
        instagram: 'yes',
        isDirectInstagram: true,
      })
      const accessToken = response?.access_token
      const userId = response?.user_id

      if (!accessToken) {
        this.$router.push({ name: 'login' })
        return
      }

      const accountData = { token: accessToken, isDirect: true }
      if (userId) {
        accountData.ig_user_id = userId
      }
      await this.addInstagramAccount(accountData)
    } catch (err) {
      if (redirectToHomeIfInWebView(self.$router)) return
      self.$router.push({ name: 'owner:home' })
      this.$router.push('/login')
      this.$store.commit('auth/SET_LOADER', false)
    }
  },
  methods: {
    async addInstagramAccount(data) {
      InstagramAccountsApi.addAccount(data).then(res => {
        if (res.error === 0) {
          this.$store.commit('instagram/SET_INSTA_ACCOUNTS', res.accounts)
          if (redirectToHomeIfInWebView(this.$router)) return
          this.$router.push({ name: 'owner:home' })
        } else {
          this.$notifyError(this.$t('auth.fail-message'))
        }
      }).catch(e => {
        this.error = e
        this.$notifyError(this.$t('auth.fail-message'))
      }).finally(() => {
        this.loading = false
        this.$store.commit('auth/SET_LOADER', false)
      })
    },
  },
}
</script>
